module.exports = __webpack_public_path__ + "img/9788983926104.4c004e35.jpg";